import React from 'react'
import { DialogProps } from '@mui/material/Dialog';
import { useMediaQuery, Dialog, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions/transition';
import {BreakPoint} from '../../styledComponents/Constants'

const UpTransition = React.forwardRef<unknown, TransitionProps>(
// @ts-ignore
    (props, ref) => <Slide direction="up" ref={ref} {...props} />,
)

const ResponsiveDialog: React.FC<DialogProps> = props => {
    const matches = useMediaQuery(`(min-width: ${BreakPoint.Sp})`)
    return (
        <Dialog
            {...props}
            fullScreen={!matches}
            TransitionComponent={matches ? undefined : UpTransition}
        >
            {props.children}
        </Dialog>
    )
}

ResponsiveDialog.displayName = 'ResponsiveDialog'
export default ResponsiveDialog
